import angular from 'angular';
import 'babel-polyfill';
import Raven from 'raven-js';
import 'angular-animate';
import 'angular-local-storage';
import 'angular-messages';
import 'angular-route';
import './main.scss';

import { CustomerAuthentication } from '@toasttab/customer-authentication';
import envFromHostname from '@toasttab/env-from-hostname';
import { Geolocation } from '@toasttab/geolocation';
import { OnlineOrderingUiKit } from '@toasttab/oo-ui-kit';
import { UiKit } from '@toasttab/ui-kit';

import '@toasttab/geolocation/dist/styles.css';
import '@toasttab/oo-ui-kit/dist/styles.css';
import '@toasttab/ui-kit/dist/styles.css';

import { AppConfig } from './app.route';
import { ComponentsModule } from './components/components.module';
import { SharedModule } from './shared/shared.module';

/* global window */
const sentryDsn = 'none' === process.env.NODE_ENV
    ? null // Don't send to sentry when running unit tests
    : 'https://d936f370cafa4b8ba2b697c1b45ec602@app.getsentry.com/1293917';
const release = process.env.PKG_VERSION;
const environment = envFromHostname(window.location.hostname);

Raven.config(sentryDsn, {
    whitelistUrls: [
        /\.toasttab\.com\//,
    ],
    release,
    environment
}).install();

export const AppModule = angular.module('oo.multilocation.picker', [
    CustomerAuthentication,
    Geolocation,
    OnlineOrderingUiKit,
    UiKit,
    ComponentsModule,
    SharedModule,
    'ngRoute',
    'ngMessages',
    'LocalStorageModule'
])
    .constant('LOCAL_STORAGE', {
        ADDRESS: 'deliveryInfo',
        DINING_OPTION: 'diningOption',
        UNSUPPORTED_MESSAGE: 'Local storage is not supported.'
    })
    .constant('DINING_OPTION', {
        DELIVERY: 'DELIVERY',
        TAKE_OUT: 'TAKE_OUT'
    })
    .config(AppConfig)
    .name;
